export default __webpack_public_path__ + "static/media/Projectiles of the Blood Drinker.18388855.jpg";